<button cs-capture-cover (click)="handleClick($event)"></button>
@if (showDayOfWeek) {
  <span class="task-calendar-day__day">{{ dayOfWeek }}</span>
}
<span class="task-calendar-day__date-number">{{ dayOfMonth }}</span>
@if (showStatus) {
  <div class="task-calendar-day__status">
    @if (getStatusIcon()) {
      <cs-icon
        [name]="getStatusIcon()"
        class="task-calendar-day__icon">
      </cs-icon>
    }
    <!-- Empty placeholder to preserve space when no icon -->
    @if (!getStatusIcon()) {
      <span class="task-calendar-day__placeholder"></span>
    }
  </div>
}
